import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ActionTriggerInsertRequest } from "../../services/ActionTriggerInsertRequest";
import { SchoolAdminService } from "../../services/schooladmin.service";

@Component({
	selector: "app-add-trigger",
	templateUrl: "./add-trigger.component.html",
	styleUrls: ["./add-trigger.component.css"],
})
export class AddTriggerComponent implements OnInit {
	constructor(
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private schoolAdminService: SchoolAdminService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		//Get Data from parent
		//this.SelectedSchoolID =
		this.SelectedSchoolID = this.dialogConfig.data.SchoolID;

		//Get Data from DB
		this.loadATT();
		this.loadATAT();
		this.loadAttendanceStatus();
		this.loadClassAttendanceStatus();
		this.loadInfraction();
		this.loadPenalty();
		this.loadATR();
		this.loadAdmin();
		this.loadMerits();

		this.loadSecondInfraction();
		this.loadSecondPenalty();
		this.loadSecondMerits();
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	//Data from parent
	SelectedSchoolID: any = 0;

	//Selections
	SelectedAttendanceStatusID: any = 0;
	SelectedClassAttendanceStatusID: any = 0;
	SelectedInfractionID: any = 0;
	SelectedPenaltyID: any = 0;
	SelectedATRID: any = 0;
	SelectedAdminID: any = 0;
	SelectedMeritID: any = 0;
	ConsecutiveInd: any = false;
	RecurrentInd: any = false;
	ActionValue: any = 0;

	SecondSelectedInfractionID: any = 0;
	SecondSelectedPenaltyID: any = 0;
	SecondSelectedMeritID: any = 0;

	//Dynamic Dropdowns
	lstAttendanceStatus: any = [];
	lstClassAttendanceStatus: any = [];
	lstInfraction: any = [];
	lstPenalty: any = [];
	lstActionTriggerReset: any = [];
	lstAdmin: any = [];
	lstMerits: any = [];

	lstSecondInfraction: any = [];
	lstSecondPenalty: any = [];
	lstSecondMerits: any = [];

	CausedByID: any = 0;
	// CausedBy: any = "Attendance, Daily";
	CausedByText: any = "Daily Attendance";

	ResultTypeID: any = 0;
	ResultsTypeText: any = "Incident";

	MeritValue: any = 0;

	lstCausedBy: any = [];

	lstCausedByText = ["Daily Attendance", "Class Attendance", "Infraction", "Penalty", "Merit/Demerit", "N/A"];

	lstActionResultType: any = [];

	lstActionResultTypeText = [
		{
			ID: 3,
			Desc: "Incident",
		},
		{
			ID: 4,
			Desc: "Merit/Demerit",
		},
	];

	errorMessage: any = "";

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	loadAttendanceStatus() {
		var result = this.schoolAdminService.AttendanceStatusSelectList("", this.SelectedSchoolID);
		result.subscribe(
			(response) => {
				this.lstAttendanceStatus = response;
				this.SelectedAttendanceStatusID = this.lstAttendanceStatus[0].AttendanceStatusID;
			},
			(error) => {}
		);
	}

	loadClassAttendanceStatus() {
		var result = this.schoolAdminService.ClassAttendanceStatusSelectList("");
		result.subscribe(
			(response) => {
				this.lstClassAttendanceStatus = response;
				this.SelectedClassAttendanceStatusID = this.lstClassAttendanceStatus[0].ClassAttendanceStatusID;
			},
			(error) => {}
		);
	}

	loadInfraction() {
		var result = this.schoolAdminService.InfractionGetList("", this.SelectedSchoolID);
		result.subscribe(
			(response) => {
				this.lstInfraction = response;
				this.SelectedInfractionID = this.lstInfraction[0].InfractionID;
			},
			(error) => {}
		);
	}

	loadPenalty() {
		//Get All penalties
		var result = this.schoolAdminService.PenaltyGetAll("", 2, 2, 2, 0, this.SelectedSchoolID, 0);
		result.subscribe(
			(response) => {
				this.lstPenalty = response;
				this.SelectedPenaltyID = this.lstPenalty[0].PenaltyID;
			},
			(error) => {}
		);
	}

	loadSecondInfraction() {
		var result = this.schoolAdminService.InfractionGetList("", this.SelectedSchoolID);
		result.subscribe(
			(response) => {
				this.lstSecondInfraction = response;
				this.SecondSelectedInfractionID = this.lstSecondInfraction[0].InfractionID;
			},
			(error) => {}
		);
	}

	loadSecondPenalty() {
		//Get penalties based on infraction
		var result = this.schoolAdminService.PenaltyGetListByInfractionID("", this.SecondSelectedInfractionID);
		result.subscribe(
			(response) => {
				this.lstSecondPenalty = response;
				this.SecondSelectedPenaltyID = this.lstSecondPenalty[0].PenaltyID;
			},
			(error) => {}
		);
	}

	loadATR() {
		var result = this.schoolAdminService.ActionTriggerResetTypeGetList("");
		result.subscribe(
			(response) => {
				this.lstActionTriggerReset = response;
				this.SelectedATRID = this.lstActionTriggerReset[0].ActionTriggerResetTypeID;
			},
			(error) => {}
		);
	}

	loadATT() {
		var result = this.schoolAdminService.ActionTriggerTypeGetList("");
		result.subscribe(
			(response) => {
				this.lstCausedBy = response;
				this.CausedByID = this.lstCausedBy[0].ActionTriggerTypeID;
			},
			(error) => {}
		);
	}

	loadATAT() {
		var result = this.schoolAdminService.ActionTriggerActionTypeGetList("");
		result.subscribe(
			(response) => {
				this.lstActionResultType = response;
				this.ResultTypeID = this.lstActionResultType[0].ActionTriggerActionTypeID;
			},
			(error) => {}
		);
	}

	loadAdmin() {
		var result = this.schoolAdminService.AdminGetList("", this.SelectedSchoolID, 1);
		result.subscribe(
			(response) => {
				this.lstAdmin = response;
				this.lstAdmin.unshift({
					Administrator: "(None)",
					AdministratorID: 0,
				});
				this.SelectedAdminID = this.lstAdmin[0].AdministratorID;
			},
			(error) => {}
		);
	}

	loadMerits() {
		var result = this.schoolAdminService.MeritGetList("", this.SelectedSchoolID, 1);
		result.subscribe(
			(response) => {
				this.lstMerits = response;
				this.SelectedMeritID = this.lstMerits[0].MeritID;
			},
			(error) => {}
		);
	}

	loadSecondMerits() {
		var result = this.schoolAdminService.MeritGetList("", this.SelectedSchoolID, 1);
		result.subscribe(
			(response) => {
				this.lstSecondMerits = response;
				this.SecondSelectedMeritID = this.lstSecondMerits[0].MeritID;
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//Get values based on selections
		var ActionFirstID: any = "";
		var ActionSecondID: any = "";
		var ActionTriggerOnID: any = "";

		//Action Trigger On ID:
		//Attendance, Daily
		if (this.CausedByID == 1) {
			ActionTriggerOnID = this.SelectedAttendanceStatusID;
		}
		//Attendance, Classroom
		else if (this.CausedByID == 2) {
			ActionTriggerOnID = this.SelectedClassAttendanceStatusID;
		}
		//Incident (Infraction)
		else if (this.CausedByID == 3) {
			ActionTriggerOnID = this.SelectedInfractionID;
		}
		//Incident (Penalty)
		else if (this.CausedByID == 4) {
			ActionTriggerOnID = this.SelectedPenaltyID;
		}
		//Merit/Demerit
		else if (this.CausedByID == 5) {
			ActionTriggerOnID = this.SelectedMeritID;
		}

		//ActionFirstID

		//Infraction
		if (this.ResultTypeID == 3) {
			ActionFirstID = this.SecondSelectedInfractionID;
			ActionSecondID = this.SecondSelectedPenaltyID;
		} else if (this.ResultTypeID == 4) {
			ActionFirstID = this.SecondSelectedMeritID;
		}

		if (this.ShowActionValue() == true && this.ActionValue <= 0) {
			this.errorMessage = "Action Value must be > 0";
			return;
		}

		let parms: ActionTriggerInsertRequest = {
			ApplicationItemID: "",
			ActionTriggerTypeID: this.CausedByID,
			ActionTriggerActionTypeID: this.ResultTypeID,
			ActionTriggerResetTypeID: this.SelectedATRID,
			Action_TriggerActionFirstID: ActionFirstID,
			Action_TriggerActionSecondID: ActionSecondID,
			ActionTriggerOnID: ActionTriggerOnID,
			ActionTriggerOnValue: this.ActionValue,
			ConsecutiveInd: this.ConsecutiveInd == true ? 1 : 0,
			RecurrentInd: this.RecurrentInd == true ? 1 : 0,
			Administrator_PersonID: this.SelectedAdminID,
			SchoolID: this.SelectedSchoolID,
		};

		var result = this.schoolAdminService.ActionTriggerInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Trigger was Added Successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Add Trigger",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////
	onCausedByChange(val) {
		this.CausedByID = val;
		this.CausedByText = this.lstCausedByText[val - 1];
	}

	onResultTypeChange(val) {
		this.ResultTypeID = val;
		this.ResultsTypeText = this.lstActionResultTypeText[val.ActionTriggerActionTypeID];
	}

	onInfractionChange(val) {
		this.SelectedInfractionID = val;
		this.loadPenalty();
	}

	onSecondInfractionChange(val) {
		this.SecondSelectedInfractionID = val;
		this.loadSecondPenalty();
	}
	onSecondSelectedMeritChange(val) {
		this.SecondSelectedMeritID = val;

		for (var i = 0; i < this.lstSecondMerits.length; i++) {
			var next = this.lstSecondMerits[i];

			if (next.MeritID == this.SecondSelectedMeritID) {
				this.MeritValue = next.MeritValue;
			}
		}
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////

	ShowCausedByMenu() {
		if (this.CausedByID != 6) {
			return true;
		} else {
			return false;
		}
	}
	ShowActionCountConsec() {
		if (this.CausedByID == 1 || this.CausedByID == 2) {
			return true;
		} else {
			return false;
		}
	}
	ShowActionValue() {
		if (this.CausedByID != 6) {
			return true;
		} else {
			return false;
		}
	}
	ShowDailyAttendance() {
		if (this.CausedByID == 1) {
			return true;
		} else {
			return false;
		}
	}
	ShowClassAttendance() {
		if (this.CausedByID == 2) {
			return true;
		} else {
			return false;
		}
	}
	ShowInfraction() {
		if (this.CausedByID == 3) {
			return true;
		} else {
			return false;
		}
	}
	ShowPenalty() {
		if (this.CausedByID == 4) {
			return true;
		} else {
			return false;
		}
	}
	ShowMeritDemerit() {
		if (this.CausedByID == 5) {
			return true;
		} else {
			return false;
		}
	}

	/////////////////////////////////////////
}
